import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CreditCard, Store, Phone, MessageCircle } from 'lucide-react';
import codeoLogo from '../../assets/codeo.png';

const phoneNumbers = [
  { number: '2664726581', display: '266 472-6581' },
  { number: '2664410705', display: '266 441-0705' },
  { number: '2664583000', display: '266 458-3000' },
];

const Footer = () => {
  return (
    <footer className="bg-gray-100 mt-auto">
      {/* Sección de características */}
      <div className="bg-gradient-to-r from-[#2d3c5d] to-[#3d4c6d] py-12">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
            {/* Medios de pago */}
            <div className="text-center flex flex-col">
              <div className="flex items-center justify-center gap-2 mb-4">
                <CreditCard className="w-8 h-8 text-[#eddacb]" />
                <h3 className="text-xl md:text-2xl font-bold text-white">
                  Medios de pago
                </h3>
              </div>
              <div className="flex flex-wrap items-center justify-center gap-6 bg-white rounded-lg shadow-lg p-6 flex-1">
                <div className="flex flex-col items-center gap-2">
                  <img src="https://http2.mlstatic.com/storage/logos-api-admin/aa2b8f70-5c85-11ec-ae75-df2bef173be2-m.svg" alt="Mercado Pago" className="h-10 md:h-12" />
                  <span className="text-xs text-gray-600 font-medium">Mercado Pago</span>
                </div>
                <div className="flex flex-col items-center gap-2">
                  <svg className="h-10 md:h-12 w-12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="2" y="5" width="20" height="14" rx="2" stroke="#2d3c5d" strokeWidth="2"/>
                    <rect x="5" y="9" width="5" height="4" rx="1" fill="#2d3c5d"/>
                    <path d="M13 15h5" stroke="#2d3c5d" strokeWidth="2" strokeLinecap="round"/>
                    <path d="M13 11h2" stroke="#2d3c5d" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                  <span className="text-xs text-gray-600 font-medium">Tarjetas</span>
                </div>
                <div className="flex flex-col items-center gap-2">
                  <svg className="h-10 md:h-12 w-12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="3" y="6" width="18" height="12" rx="2" stroke="#2d3c5d" strokeWidth="2"/>
                    <path d="M3 10h18" stroke="#2d3c5d" strokeWidth="2"/>
                    <path d="M7 14h4" stroke="#2d3c5d" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                  <span className="text-xs text-gray-600 font-medium">Transferencia</span>
                </div>
                <div className="flex flex-col items-center gap-2">
                  <svg className="h-10 md:h-12 w-12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="2" y="4" width="20" height="16" rx="2" stroke="#2d3c5d" strokeWidth="2"/>
                    <path d="M2 8h20" stroke="#2d3c5d" strokeWidth="2"/>
                    <circle cx="12" cy="14" r="2" stroke="#2d3c5d" strokeWidth="2"/>
                  </svg>
                  <span className="text-xs text-gray-600 font-medium">Efectivo</span>
                </div>
              </div>
            </div>

            {/* Retiro en depósito */}
            <div className="text-center flex flex-col">
              <div className="flex items-center justify-center gap-2 mb-4">
                <Store className="w-8 h-8 text-[#eddacb]" />
                <h3 className="text-xl md:text-2xl font-bold text-white">
                  Retirá en nuestros depósitos
                </h3>
              </div>
              <div className="bg-white rounded-lg shadow-lg p-6 flex-1 flex flex-col items-center justify-center gap-2">
                <p className="text-gray-700 text-lg font-medium">
                  Pasá a retirar por nuestros depósitos sin costo adicional
                </p>
                <p className="text-[#2d3c5d] font-semibold">
                  Ruta 3 y Salvador Segado, San Luis, Argentina
                </p>
                <p className="text-gray-500 text-sm">
                  Lunes a Viernes de 09:00 a 17:00 hs
                </p>
                <p className="text-gray-500 text-sm">
                  Sábados de 09:00 a 14:00 hs
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Sección de contacto telefónico */}
      <div className="bg-[#1f2a3d] py-6">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8">
            <p className="text-white font-medium">¿Tenés dudas? ¡Contactanos!</p>
            <div className="flex flex-wrap justify-center gap-3 md:gap-4">
              {phoneNumbers.map((phone) => (
                <div key={phone.number} className="flex items-center gap-2">
                  <a
                    href={`tel:+54${phone.number}`}
                    className="flex items-center gap-2 px-3 py-1.5 bg-white/10 hover:bg-white/20 rounded-full transition-all text-white text-sm"
                  >
                    <Phone className="w-4 h-4" />
                    <span>{phone.display}</span>
                  </a>
                  <a
                    href={`https://wa.me/54${phone.number}?text=Hola! Vengo desde la web de Deco Home Sin Rival`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center w-8 h-8 bg-green-500 hover:bg-green-600 rounded-full transition-all"
                  >
                    <MessageCircle className="w-4 h-4 text-white" />
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Links del footer */}
      <div className="py-12 bg-white border-t border-gray-200">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-lg font-bold text-[#2d3c5d] mb-5 uppercase tracking-wide">Sobre nosotros</h3>
              <ul className="space-y-3">
                <li>
                  <Link to="/nosotros" className="text-gray-700 hover:text-[#2d3c5d] hover:underline transition-all flex items-center gap-2 group">
                    <span className="w-1.5 h-1.5 bg-[#eddacb] rounded-full group-hover:bg-[#2d3c5d] transition-colors"></span>
                    Quiénes somos
                  </Link>
                </li>
                <li>
                  <Link to="/contacto" className="text-gray-700 hover:text-[#2d3c5d] hover:underline transition-all flex items-center gap-2 group">
                    <span className="w-1.5 h-1.5 bg-[#eddacb] rounded-full group-hover:bg-[#2d3c5d] transition-colors"></span>
                    Contacto
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-bold text-[#2d3c5d] mb-5 uppercase tracking-wide">Información</h3>
              <ul className="space-y-3">
                <li>
                  <Link to="/medios-de-pago" className="text-gray-700 hover:text-[#2d3c5d] hover:underline transition-all flex items-center gap-2 group">
                    <span className="w-1.5 h-1.5 bg-[#eddacb] rounded-full group-hover:bg-[#2d3c5d] transition-colors"></span>
                    Medios de pago
                  </Link>
                </li>
                <li>
                  <Link to="/preguntas-frecuentes" className="text-gray-700 hover:text-[#2d3c5d] hover:underline transition-all flex items-center gap-2 group">
                    <span className="w-1.5 h-1.5 bg-[#eddacb] rounded-full group-hover:bg-[#2d3c5d] transition-colors"></span>
                    Preguntas frecuentes
                  </Link>
                </li>
                <li>
                  <Link to="/envios" className="text-gray-700 hover:text-[#2d3c5d] hover:underline transition-all flex items-center gap-2 group">
                    <span className="w-1.5 h-1.5 bg-[#eddacb] rounded-full group-hover:bg-[#2d3c5d] transition-colors"></span>
                    Información de envíos
                  </Link>
                </li>
                <li>
                  <Link to="/cambios-devoluciones" className="text-gray-700 hover:text-[#2d3c5d] hover:underline transition-all flex items-center gap-2 group">
                    <span className="w-1.5 h-1.5 bg-[#eddacb] rounded-full group-hover:bg-[#2d3c5d] transition-colors"></span>
                    Cambios y devoluciones
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-bold text-[#2d3c5d] mb-5 uppercase tracking-wide">Legal</h3>
              <ul className="space-y-3">
                <li>
                  <Link to="/terminos-condiciones" className="text-gray-700 hover:text-[#2d3c5d] hover:underline transition-all flex items-center gap-2 group">
                    <span className="w-1.5 h-1.5 bg-[#eddacb] rounded-full group-hover:bg-[#2d3c5d] transition-colors"></span>
                    Términos y condiciones
                  </Link>
                </li>
                <li>
                  <Link to="/privacidad" className="text-gray-700 hover:text-[#2d3c5d] hover:underline transition-all flex items-center gap-2 group">
                    <span className="w-1.5 h-1.5 bg-[#eddacb] rounded-full group-hover:bg-[#2d3c5d] transition-colors"></span>
                    Política de privacidad
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="bg-[#2d3c5d] py-4">
        <div className="container mx-auto px-4">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4">
            <p className="text-center text-sm" style={{ color: '#eddacb' }}>
              © {new Date().getFullYear()} Deco Home - Sin Rival. Todos los derechos reservados.
            </p>
            <span className="hidden sm:block text-white/30">|</span>
            <CodeoCredit />
          </div>
        </div>
      </div>
    </footer>
  );
};

// Componente con efecto máquina de escribir
const CodeoCredit = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [displayText, setDisplayText] = useState('');
  const fullText = 'Codeo.Ar';

  useEffect(() => {
    if (isHovered) {
      setDisplayText('');
      let index = 0;
      const interval = setInterval(() => {
        if (index < fullText.length) {
          setDisplayText(fullText.slice(0, index + 1));
          index++;
        } else {
          clearInterval(interval);
        }
      }, 80);
      return () => clearInterval(interval);
    } else {
      setDisplayText('');
    }
  }, [isHovered]);

  return (
    <a
      href="https://www.instagram.com/codeo.ar"
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-2 text-white/60 hover:text-white transition-all group"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <span className="text-xs">Desarrollado por</span>
      <img
        src={codeoLogo}
        alt="Codeo"
        className="h-5 w-auto group-hover:scale-110 transition-transform"
      />
      <span className="text-xs font-medium min-w-[55px] text-left">
        {isHovered ? displayText : ''}
        {isHovered && <span className="animate-pulse">|</span>}
      </span>
    </a>
  );
};

export default Footer;
